// Module
var code = "<button class=\"spinner-button-component spinner-button btn btn-default {{buttonTheme}}\" [disabled]=\"isSpinning || isDisabled\" (click)=\"onClicked()\"> <img [src]=\"spinnerResource\" [hidden]=\"!isSpinning\"/> <span [style.visibility]=\"isSpinning ? 'hidden': 'visible'\"> <ng-content></ng-content> </span> </button> ";
// Exports
export default code;